import { useState, useEffect, useMemo, useCallback } from 'react'

export const useTournamentValidation = (tournament, userData) => {
  const [errorMessage, setErrorMessage] = useState('')

  const checkDetails = useCallback(() => {
    if (!tournament?.details || !userData) return

    if (tournament?.details?.minimumAge > userData?.age) {
      setErrorMessage(
        'Players must be at least ' + tournament?.details?.minimumAge
      )
    } else if (
      tournament?.details?.gender !== 'Other' &&
      tournament?.details?.gender !== userData?.gender
    ) {
      setErrorMessage('Players must be ' + tournament?.details?.gender)
    } else if (!tournament?.details?.countries.includes(userData?.country)) {
      setErrorMessage(
        `Players from ${userData?.country} not available for this tournament`
      )
    } else {
      setErrorMessage('')
    }
  }, [tournament?.details, userData])

  const isValidForRegistration = useMemo(
    () => !errorMessage && userData?.profileInfoFilled,
    [errorMessage, userData?.profileInfoFilled]
  )

  useEffect(() => {
    checkDetails()
  }, [checkDetails])

  return {
    errorMessage,
    setErrorMessage,
    isValidForRegistration,
    checkDetails,
  }
}
